const SET_ROW_DATA = 'SET_ROW_DATA'
let rowData=window.localStorage.getItem("rowData");
const mall = {
  state: {
    rowData: rowData?JSON.parse(rowData):{}
  },
  mutations: {
    [SET_ROW_DATA](state, data) {
      window.localStorage.setItem("rowData", JSON.stringify(data));
      state.rowData = data;
    }
  },
  actions: {}
}

export default mall



// WEBPACK FOOTER //
// ./src/store/modules/mall.js